import http from './http'

const atualizacaoService = {
  getAll: page => http.get(`/ged?page=${page}`).then(result => result.data),
  getById: (ano, dtini, dtfim, setor, documento, search, localizarpdf, page) => http.get(`/gedbyid/${ano}/${dtini}/${dtfim}/${setor}/${documento}/${search}/${localizarpdf}?page=${page}`).then(result => result.data),
  getByNome: (str, page) => http.get(`/gednome/${str}?page=${page}`).then(result => result.data),
  getPdf: (id) => http.get(`/getpdf/${id}`).then(result => result.data.data),
  getId: (id) => http.get(`/getid/${id}`).then(result => result.data.data),
  getEmail: (id, email, assunto, body) => http.get(`/gedemail/${id}/${email}/${assunto}/${body}`).then(result => result.data.data),
  sendFile: data => http.post('/ged', data, { headers: { 'Content-Type': 'multipart/form-data' } }).then(result => result.data),
  getSetor: () => http.get(`/getsetor`).then(result => result.data),
  getSetorTodos: () => http.get(`/getsetortodos`).then(result => result.data),
  getDocumento: () => http.get(`/getdocumento`).then(result => result.data),
  getDocumentoTodos: () => http.get(`/getdocumentotodos`).then(result => result.data),
  delete: id => http.delete(`/geddelete/${id}`),
  savePut: data => http({
    method: 'put',
    url: `/usuarios/${data.id}`,
    data
  }).then(result => result.data.data)
}
export default atualizacaoService
